/**
 * 제보에 첨부할 최근 클라이언트 에러를 모아두는 링 버퍼.
 *
 * 버그 제보에서 가장 아쉬운 게 "무슨 에러가 났는지"라서,
 * console.error / 전역 에러 / 미처리 rejection을 앱 시작 시점부터 붙잡아 둔다.
 * 메모리에만 남고 서버로는 제보를 보낼 때만 전송된다.
 */

const MAX_ENTRIES = 10;
const MAX_MESSAGE_LENGTH = 1000;

let buffer: string[] = [];
let installed = false;

function push(message: string): void {
  const trimmed = message.slice(0, MAX_MESSAGE_LENGTH);
  const stamped = `[${new Date().toISOString()}] ${trimmed}`;

  // 최근 것이 앞에 오도록 유지
  buffer = [stamped, ...buffer].slice(0, MAX_ENTRIES);
}

function stringifyArg(arg: unknown): string {
  if (arg instanceof Error) {
    return `${arg.name}: ${arg.message}${arg.stack ? `\n${arg.stack}` : ""}`;
  }
  if (typeof arg === "string") {
    return arg;
  }
  try {
    return JSON.stringify(arg);
  } catch {
    return String(arg);
  }
}

/** 앱 시작 시 한 번만 호출한다. */
export function installConsoleErrorBuffer(): void {
  if (installed || typeof window === "undefined") {
    return;
  }
  installed = true;

  const originalError = console.error;
  console.error = (...args: unknown[]) => {
    push(args.map(stringifyArg).join(" "));
    originalError.apply(console, args);
  };

  window.addEventListener("error", (event) => {
    push(
      `Uncaught ${event.message} (${event.filename}:${event.lineno}:${event.colno})`,
    );
  });

  window.addEventListener("unhandledrejection", (event) => {
    push(`Unhandled rejection: ${stringifyArg(event.reason)}`);
  });
}

/** 최근 에러 목록 (최신순) */
export function getRecentConsoleErrors(): string[] {
  return [...buffer];
}

export function clearConsoleErrorBuffer(): void {
  buffer = [];
}
